

import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Mutation } from "vuex-class"

import api from "@/services/api"
import eventApi from "@/services/api.event"

import { CaseDetails } from "@/types"
import { CaseEvents, KeyMedia as KeyMediaEntry } from "@/types/originatingEvents"

const caseStore = namespace("cases")

@Component({
	components: {
	}
})
export default class KeyMedia extends Vue {
	@Prop()
	mediaClip!: KeyMediaEntry;

	@Prop({ type: Boolean, default: false })
	public displayAsList!: boolean;

	@Prop()
	public currentCase!: CaseDetails;

	@Prop()
	canEditCurrentCase!: boolean;

	@caseStore.Mutation
	public setPreviewKeyMedia!: (file: any) => void;

	private get thumbnailPath (): string {
		return api.baseUrl + `event/download/${this.currentCase.id}/${this.mediaClip.id}?thumbnail=true`
	}

	private extension (filename: string): string {
		return filename.substring(filename.lastIndexOf(".") + 1)
	}

	private removeFile () {
		eventApi.mediaMarkKey(this.currentCase!.id!, this.mediaClip.id, false)
	}
}
